import type { IBuildGemXQlQueryParams } from '~/core/gemxql';

import { buildGemXQlQuery, EGroupWithClause } from '~/core/gemxql';

type BuildOrderQueryParams = Pick<
  IBuildGemXQlQueryParams,
  | 'mode'
  | 'metrics'
  | 'sources'
  | 'dimensions'
  | 'dateRange'
  | 'filters'
  | 'orderBy'
  | 'limit'
  | 'offset'
  | 'versionIds'
  | 'extraConditions'
>;

export const buildOrderQuery = (params: BuildOrderQueryParams) =>
  buildGemXQlQuery({ ...params, groupWithClause: EGroupWithClause.NONE });
